import PageLayer from "@/Layouts/views/PageLayer";
import UserAccessSettingsLayer from "../../components/UserAccessSettings/UserAccessSettingsLayer";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/settings/UserAccessSettingsIcon.svg";

export default function UserAccessSettings() {
	return (
		<PageLayer
			title={"User Access Settings"}
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon viewBox="-2 -2 24 24" className="text-[var(--medium-pink-color)] !text-[25px]" component={Icon} />
				</Stack>
			}
		>
			<UserAccessSettingsLayer />
		</PageLayer>
	);
}
